//https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
var storageAvailable = function (type) {
    var storage, x;
    try {
        storage = window[type];
        x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;    
    } catch (e) {
        return e instanceof DOMException && (
                // everything except Firefox
                e.code === 22 || 
                // Firefox
                e.code === 1014 ||
                // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' ||
                // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage.length !== 0;
    }
}

//https://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
var setCookie = function (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

var getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

$().ready(function () {
    $('.gdpr-popup').each(function () {
        var $popup = $(this),
            popupTimeout,
            popupOnTop;

        popupTimeout = ($popup.is('[data-gdpr-timeout]')) ? parseInt($popup.attr('data-gdpr-timeout')) : 1000;

        popupOnTop = $popup.is('[data-gdpr-pos]');
 
            $('body').addClass('will-have-popup')


        var togglePopup = function (val) {
            $popup.toggleClass('visible', val);
                $('body').toggleClass('has-popup', val);

        }

        $(window).on('load',function () {
            var wasAccepted;
            if (storageAvailable('localStorage'))
                wasAccepted = !!localStorage.getItem('gdpr-accepted');
            else
                wasAccepted = !!getCookie('gdpr');
 
            if (!wasAccepted) {
                setTimeout(function () {
                    togglePopup(true);
                })
            }
        })

        $('.gdpr-close').on('click', function () {
            if (storageAvailable('localStorage'))
                localStorage.setItem('gdpr-accepted', '1');
            else
                setCookie('gdpr', '1');

            togglePopup(false);
        })
        $('.gdpr-continue').on('click', function () {
            if (storageAvailable('localStorage'))
                localStorage.setItem('gdpr-accepted', '1');
            else
                setCookie('gdpr', '1');

            togglePopup(false);
        })
    })
});